<template>
    <div class="box m-b-0 box-modal">
        <div class="box-header">
            <h3>{{ title }}</h3>
        </div>
        <div class="box-tool">
            <ul class="nav">
                <li class="nav-item inline icon-with-desc">
                    <a class="nav-link text-muted" @click="$emit('close')">
                        <i class="material-icons md-18">clear</i>
                        <span class="icon-desc">ESC</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="box-body" v-if="isLoading">
            <div class="spinner"/> ładowanie...
        </div>
        <div style="min-height:280px;"  class="box-body" v-else>
            <div v-if="!elements.length" class="text-center p-a">
                Brak elementów do wyświetlenia
            </div>
            <template v-else>
                <v-box v-for="(element, index) in elements" :key="'element_' + index" class="m-b" :title="keys.header ? keys.header(element) : ''" :hasESCButton="false" :hasFooter="!!keys.footer">

                    <div v-if="keys.body" class="text-xs text-muted" v-html="keys.body(element)"/>
                    <div v-else class="text-xs text-muted">{{ element + '' }}</div>

                    <template slot="footer" v-if="keys.footer">
                        <div class="text-xs text-muted" v-html="keys.footer(element)"/>
                    </template>

                </v-box>
            </template>
        </div>
        <div class="box-footer clearfix">
            <button class="btn white none-radius btn-sm" @click="$emit('close')">Zamknij</button>
        </div>
    </div>
</template>

<script>
import { has } from 'object-path';
import { deepCopy } from '../Utils';

/**
 * Okno modalne ogólnego użytku do wyświetlania listy elementów
 * Może być używane do wyświetlania listy elementów, które nie wymagają edycji
 */
export default {
    name: 'GenericListModal',
    props: {

        /**
         * Tytuł okna modalnego
         */
        title: String,

        /**
         * Dane do wyświetlenia w liście.
         * Może być to tablica obiektów lub funkcja zwracająca tablicę obiektów.
         */
        data: {
            type: [Array, Function],
            default: () => []
        },

        /**
         * Obiekt z kluczami, które będą używane do wyświetlania elementów,
         * dostępne klucze to `header`, `body`, `footer`. Czyli np.:
         * {
         *   header: (element) => element.name,
         *   body: (element) => element.description,
         *   footer: (element) => element.date
         * }
         * Jeśli nie podano, to domyślnie będzie używany element jako tekst
         */
        keys: Object
    },
    components: {
        // Datepicker
    },
    data() {
        return {
            isLoading: false,
            elements: []
        }
    },
    created: async function() {
        window.addEventListener('keydown', this.handleKeyUp);

        this.isLoading = true;

        if (typeof this.data === 'function') {
            try {
                this.elements = await this.data();
            } catch (error) {
                this.$h.commonApiError(error, true);
                this.$emit('close');
            }
        } else {
            this.elements = deepCopy(this.data);
        }

        this.isLoading = false;
    },
    destroyed: function() {
        window.removeEventListener('keydown', this.handleKeyUp);
    },
    methods: {

        handleKeyUp: function(e) {
            if (e.keyCode == 27) { // ESC
                e.preventDefault();
                this.$emit('close');
            }
        }

    }
}
</script>
